import { useApi } from "@api/ApiProvider";
import { useQuery } from "@tanstack/react-query";
import { getCustomPromptsApi } from "./customPrompts.api";
import { customPromptsQueryKey, normalizeUserPrompts } from "./utils";

export const useCustomPromptsQuery = () => {
  const { api } = useApi();

  return useQuery({
    queryKey: customPromptsQueryKey(),
    queryFn: async () => normalizeUserPrompts(await getCustomPromptsApi(api)),
  });
};
